import { trpc } from '@/shared/api';

/** 편집영역 템플릿 전체 목록. */
export const useEditAreaTemplatesQuery = () =>
  trpc.productManagement.editAreaTemplates.list.useQuery();
